import {
  SETTINGS_ERROR,
  SETTINGS_FETCH,
  SETTINGS_SUCCESS,
} from './settingsActionConstants';

export const fetchSettings = () => ({
  type: SETTINGS_FETCH,
});

export const setSettings = (payload) => ({
  type: SETTINGS_SUCCESS,
  payload,
});

export const setSettingsError = (payload) => ({
  type: SETTINGS_ERROR,
  payload,
});
